import React, { useMemo, useState, useEffect } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { usePartnerQuotaUIContext } from "../PartnerQuotaUIContext";
import { initialFilter } from "../PartnerQuotaUIHelpers";

const prepareFilter = (queryParams, values) => {
  const { partner, livestock, area } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  //add to Object filter
  filter.partner = partner ?? "";
  filter.livestock = livestock ?? "";
  filter.area = area ?? "";
  newQueryParams.filter = filter;
  return newQueryParams;
};

export const PartnerQuotaFilter = ({ listLoading }) => {
  // PartnerQuota UI Context
  const partnerQuotaUIContext = usePartnerQuotaUIContext();
  const partnerQuotaUIProps = useMemo(() => {
    return {
      setQueryParams: partnerQuotaUIContext.setQueryParams,
      queryParams: partnerQuotaUIContext.queryParams,
      filterType: partnerQuotaUIContext.filterType,
    };
  }, [partnerQuotaUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(partnerQuotaUIProps.queryParams, values);
    if (!isEqual(newQueryParams, partnerQuotaUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      partnerQuotaUIProps.setQueryParams(newQueryParams);
    }
  };

  return (
    <Formik
      initialValues={initialFilter.filter}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="mb-3 col-lg-mb-0 col-lg-4">
              <input
                type="text"
                className="form-control"
                name="partner"
                placeholder="Search"
                onBlur={handleBlur}
                value={values.partner}
                onChange={(e) => {
                  setFieldValue("partner", e.target.value);
                }}
              />
              <small className="form-text text-muted">
                <b>Cari</b> Berdasarkan Mitra
              </small>
            </div>
            <div className="mb-3 col-lg-mb-0 col-lg-4">
              <input
                type="text"
                className="form-control"
                name="livestock"
                placeholder="Search"
                onBlur={handleBlur}
                value={values.livestock}
                onChange={(e) => {
                  setFieldValue("livestock", e.target.value);
                }}
              />
              <small className="form-text text-muted">
                <b>Cari</b> Berdasarkan Hewan
              </small>
            </div>
            <div className="mb-3 col-lg-mb-0 col-lg-4">
              <input
                type="text"
                className="form-control"
                name="area"
                placeholder="Search"
                onBlur={handleBlur}
                value={values.area}
                onChange={(e) => {
                  setFieldValue("area", e.target.value);
                }}
              />
              <small className="form-text text-muted">
                <b>Cari</b> Berdasarkan Wilayah
              </small>
            </div>
            <div className="mb-3 col-lg-mb-0 col-12 d-flex flex-row-reverse">
              <div className="btn btn-warning" onClick={() => handleSubmit()}>Terapkan</div>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
